import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {getTableRowClass, getAgencyInfo, formatAsMoney}  from "../../../Withdrawal/utils/utils";
import { Link } from "react-router-dom";
import moment from 'moment'
import {matchedFieldTranslation} from '../../utils/utils'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  blueText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82"
},
redText: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#D91A1A"
},
  tableText: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "16px",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  }
}));

const getMatchedFields = (transactions) => {
    let matchedFieldsArray = []
    for(let transaction of transactions){
        matchedFieldsArray.push(Object.keys(transaction['highlight']))
    }
    for(let matchedField of matchedFieldsArray){
        if(matchedField.indexOf('company_key')>-1){
                let ckIndex = matchedField.indexOf('company_key')
                matchedField.splice(ckIndex,1)
        }
    }
    return matchedFieldsArray 
}

const getAgencies=(wire_trasnfer_account_object)=>{
    let [institution_name] = getAgencyInfo(wire_trasnfer_account_object)
    if(institution_name){
        return institution_name
    }else{
        return wire_trasnfer_account_object.participant
    }
}

function WithdrawalSearchTable(props) {

    const matchedFieldsArray = getMatchedFields(props.historic)
    
    const classes = useStyles();
    useTheme();

    return (
        <Paper className={classes.tableStyle}>
        <Table style={{ padding: "8px"}}>
            <TableHead>
            <TableRow>
                <TableCell className={classes.tableHeader} style={{ width: "5%" }}>ID</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "8%" }}>Valor</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "20%" }}>Nome Cliente</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "12%" }}>Doc Cliente</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "28%" }}>Instituição Origem</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "12%" }}>Data de Saque</TableCell>
                <TableCell className={classes.tableHeader} style={{ width: "15%" }}>Campo encontrado</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {props.historic.map((withdrawal,index) => (
                <TableRow
                key={index}
                className={getTableRowClass(index)}
                > 
                <TableCell
                    className={[classes.tableText, classes.blueText, "link", "idOverflow"].join(" ")}
                >
                    <Link
                        className="link"
                        to={"/withdrawal/" + withdrawal.withdrawal_key}
                    >
                    {withdrawal.id}
                    </Link>
                </TableCell>
                <TableCell className={classes.tableText}>
                    {formatAsMoney(withdrawal.amount, "-")}
                </TableCell>
                <TableCell className={classes.tableText} >
                    <div className={
                        matchedFieldsArray[index].includes("client.name")
                        ? "blueTextSearchAny"
                        : null}
                        >
                        {withdrawal.client.name}
                    </div>
                </TableCell>
                <TableCell className={classes.tableText}>
                    <div className={
                        matchedFieldsArray[index].includes("client.document_number")
                        ? "blueTextSearchAny"
                        : null}
                        >
                        {withdrawal.client.document_number}
                    </div>
                </TableCell>
                <TableCell className={classes.tableText}>
                    <div className={
                        matchedFieldsArray[index].includes("source_account.participant")
                        ? "blueTextSearchAny"
                        : null}
                        >
                        {getAgencies(withdrawal.source_account)}
                    </div>
                </TableCell>
                <TableCell className={classes.tableText}>
                    {moment(withdrawal.withdrawal_date).format("DD/MM/YYYY HH:mm")}
                </TableCell>
                <TableCell className={classes.tableText}>
                    {matchedFieldsArray[index].map(matchedField => matchedFieldTranslation(matchedField)).join(", ")}
                </TableCell>
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </Paper>
    );
}

export default WithdrawalSearchTable;
